import React from 'react'
import { Route, Switch } from 'react-router-dom'

import ExternalApplicationStatistics from './ExternalApplicationStatistics'
import { externalApplicationStaticsRoute } from 'routes/routeNames'

const ExternalApplicationStatisticsContainer: React.FC = () => (
  <Switch>
    <Route exact path={externalApplicationStaticsRoute} component={ExternalApplicationStatistics} />
  </Switch>
)

export default ExternalApplicationStatisticsContainer
